import React, { ReactElement } from 'react';

import { useTheme } from '../../../hooks';
import { ButtonChildrenPosition, ButtonContainer } from '../../button';
import { ContactUsFormContainer } from '../../forms';
import { IconHelpComponent } from '../../icons';
import { HelpButtonContainerStyled } from './helpButton.styled';
import { HelpButtonContainerProps } from './helpButton.model';
import { useHelpContext } from './helpButton.context';

export const HelpButtonContainer = ({
  title,
  color,
  formInputColor,
  formInputBordered,
  personal,
  usagePosition,
}: HelpButtonContainerProps): ReactElement => {
  const theme = useTheme();
  const { handleClosePopup, handleOpenPopup, isPopupOpened } = useHelpContext();

  return (
    <>
      <HelpButtonContainerStyled>
        <ButtonContainer
          title={title}
          color={color}
          childrenPosition={ButtonChildrenPosition.left}
          onClick={handleOpenPopup.bind(null, usagePosition)}
        >
          <IconHelpComponent
            fillColor={theme.COLOR.TEXT_DARK_COLOR}
            strokeColor={theme.COLOR.TEXT_DARK_COLOR}
          />
        </ButtonContainer>
      </HelpButtonContainerStyled>

      <ContactUsFormContainer
        open={isPopupOpened}
        handleClose={handleClosePopup}
        inputColor={formInputColor}
        inputBordered={formInputBordered}
        personal={personal}
        usagePosition={usagePosition}
      />
    </>
  );
};
